<template>
    <v-container class="pa-5" fluid>
        <page-title>Raportowanie / Szczegóły raportu</page-title>

        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-title>
                                    <template v-if="isProcessReport">
                                        Czynność - {{ shipmentReport.reportProcessCode.name }}
                                    </template>
                                    <template v-else>
                                        Zamówienie {{ shipmentReport.orderProductionNumber }}
                                    </template>
                                </v-card-title>
                                <v-divider />

                                <v-card-text>
                                    <v-container class="pa-0">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="6" lg="4" class="d-flex">
                                                <v-icon class="mr-2" color="success">
                                                    mdi-timer-outline
                                                </v-icon>
                                                <span class="text-subtitle-1">
                                                    <strong>Data rozpoczęcia:</strong>
                                                    {{ formatDate(shipmentReport.start) }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6" lg="4" class="d-flex">
                                                <v-icon class="mr-2" color="error">
                                                    mdi-timer-off-outline
                                                </v-icon>
                                                <span class="text-subtitle-1">
                                                    <strong>Data zakończenia:</strong>
                                                    {{ formatDate(shipmentReport.finish) }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6" lg="4" class="d-flex">
                                                <v-icon class="mr-2" color="info">
                                                    mdi-clock-outline
                                                </v-icon>
                                                <span class="text-subtitle-1">
                                                    <strong>Czas trwania:</strong>
                                                    <template v-if="isReportFinished">
                                                        {{ parseDuration(shipmentReport.duration) }}
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="timeWithoutLimit">
                                                            {{ parseDuration(timeWithoutLimit) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ parseDuration(duration) }}
                                                        </template>
                                                    </template>
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="isReportFinished && !isProcessReport" cols="12">
                            <v-card>
                                <v-toolbar flat dense color="white lighten-2">
                                    <v-toolbar-title>Parametry raportu</v-toolbar-title>
                                </v-toolbar>
                                <v-divider />
                                <v-card-text>
                                    <v-container class="pa-0">
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <table class="table table--simple">
                                                    <tbody>
                                                        <tr>
                                                            <th>Ilość kartonów:</th>
                                                            <td>{{ shipmentReport.shippedBoxes }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Waga sumaryczna:</th>
                                                            <td>{{ formatWeight( shipmentReport.shippedWeight ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-btn
                                v-if="!isReportFinished && isProcessReport"
                                :loading="stopTrackingLoading"
                                color="error"
                                data-sentry-label="Zakończ"
                                @click="stopTracking"
                            >
                                Zakończ
                            </v-btn>
                            <v-btn
                                v-if="isReportFinished"
                                color="error"
                                class="mr-4"
                                :disabled="stopTrackingLoading"
                                data-sentry-label="Wstecz"
                                @click="close"
                            >
                                Wstecz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import PageTitle from '@/components/common/PageTitle'

import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import weightFormatter from '@/mixins/weightFormatter'

import { errorHandler } from '@/utils/errorHandler'


export default {
    name: 'ShipmentReport',
    components: {
        PageTitle
    },
    mixins: [
        dateFormatter,
        parse,
        weightFormatter
    ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('reports/getDetailedShipmentReport', to.params.id)
            .then(response => {
                next(vm => {
                    vm.shipmentReport = Object.assign({}, response)
                    if (!vm.isReportFinished) vm.setDuration()
                    vm.routeParentName = to.matched.slice(-1)[0]?.parent.name
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    data() {
        return {
            shipmentReport: {},
            confirmNextReportCreationDialog: false,
            routeParentName: null,
            duration: null,
            remainingTime: null,
            stopTrackingLoading: false,
            timeWithoutLimit: 0,
            intervalId: null,
        }
    },
    computed: {
        isProcessReport() {
            return this.shipmentReport.reportProcessCodeId ? true : false
        },
        isReportFinished() {
            if (this.shipmentReport.statusId) {
                return this.shipmentReport.statusId == 99
            }

            return false
        },
    },
    destroyed() {
        clearInterval(this.intervalId)
    },
    methods: {
        setDuration() {
            const currentServerDateTime = new Date(this.shipmentReport.currentServerDateTime).getTime()
            const start = new Date(this.shipmentReport.start).getTime()
            const timeElapsed = Math.floor((currentServerDateTime - start) / 1000)

            this.shipmentReport.remainingTime == null ? this.remainingTime = 0 : this.remainingTime = this.shipmentReport.remainingTime

            if (timeElapsed >= this.remainingTime) { // przekroczono czas wykonania -> nie ma limitu
                this.shipmentReport.remainingTime == null ? this.timeWithoutLimit = timeElapsed : this.delay = Math.floor(timeElapsed - this.remainingTime)
                this.duration = -1
            }
            if (this.shipmentReport.statusId === 1) {
                this.refreshDuration()
                this.intervalId = setInterval(this.refreshDuration, 1000)
            }
        },
        refreshDuration() {
            if (this.duration >= 0) {
                this.duration -= 1
            }
            if (this.duration == -1) {
                this.shipmentReport.remainingTime == null ? this.timeWithoutLimit += 1 : this.delay += 1
            }
        },
        stopTracking() {
            this.finishReport()
        },
        close() {
            this.$router.push({ name: this.routeParentName })
                .catch(error => {
                    errorHandler(error)
                })
        },
        finishReport() {
            this.stopTrackingLoading = true

            this.$store.dispatch('shipments/sendings/finishShipmentReport', {
                id: this.shipmentReport.id,
                payload: {
                    reportProcessCodeId: this.shipmentReport.reportProcessCodeId,
                    productionSiteId: this.shipmentReport.productionSiteId,
                    statusId: 99
                }
            })
                .then(() => {
                    this.$router.push({ name: 'shipmentsSendings' })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.stopTrackingLoading = false
                        })
                })
                .catch(error => {
                    errorHandler(error)
                    this.stopTrackingLoading = false
                })
        },
    }
}
</script>
